import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-page-header',
  templateUrl: './services-page-header.component.html',
  styleUrls: ['./services-page-header.component.css']
})
export class ServicesPageHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
